import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { EditLivetvDTO, livetvActiveDTO, LivetvDTO, livetvStatusDTO } from './dto/livetv.dto';
import { livetvResponseModel,AlllivetvResponseModel, livetvstatusResponseModel } from './livetv-response-module';
import { LivetvEntity } from './livetv.entity';
import * as fs from 'fs';
import { sendFCMNotifications } from '../shared/mobileOTP';
import { UserEntity } from '../user/user.entity';
import { NotificationsEntity } from '../notifications/notifications.entity';

@Injectable()
export class LivetvService {
    constructor(
        @InjectRepository(LivetvEntity)
        private livetvRepository: Repository<LivetvEntity>,
        @InjectRepository(UserEntity)
        private useRepo:Repository<UserEntity>,
        @InjectRepository(NotificationsEntity)
        private notifyRepo:Repository<NotificationsEntity>,
    ) {}

    async sendNotify(text) {
        return await sendFCMNotifications(text)
        .then(() => {      
          console.log('notification sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending notification ', err);
          return false;
        });
    }

    async createlivetv(queryParams, LivetvDTO:LivetvDTO, fileImg, request: Request): Promise<livetvResponseModel> {
        const response = new livetvResponseModel();
        try {
            console.log(fileImg);
            LivetvDTO.status = true;
            if(queryParams.apiVersion == 1) {
                const savedPostType = await this.livetvRepository.save(LivetvDTO);
                console.log('first',savedPostType)
                const savedimg = await this.livetvRepository.update(savedPostType.Id,fileImg[0]);
                console.log('img',savedimg)
                const savedData = await this.livetvRepository.findOne({
                    where:{Id:savedPostType.Id}
                });
                console.log('get',savedData)
                if(savedData) {
                    savedData.livetvThumbnail = savedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${savedData.livetvThumbnail}`:'';
                    response.status = true;
                    response.data   = savedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details posted Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'livetv details Not posted')
                }
            } else {
                const savedPostType = await this.livetvRepository.save(LivetvDTO);
                const savedimg = await this.livetvRepository.update(savedPostType.Id,fileImg[0]);
                const savedData = await this.livetvRepository.findOne({
                    where:{Id:savedPostType.Id}
                });
                if(savedData) {
                    savedData.livetvThumbnail = savedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${savedData.livetvThumbnail}`:'';
                    response.status = true;
                    response.data   = savedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details posted Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'livetv details Not posted')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    /* async updatelivetv(queryParams, LivetvDTO: LivetvDTO, fileImg, changeImg,request:Request): Promise<livetvResponseModel> {
        const response = new livetvResponseModel();
        try {
            const user = await this.useRepo.findOne({
                relations:['profile'],
                where:{Id:LivetvDTO.updatedUser}
            })
            if(queryParams.apiVersion == 1) {
                const updatePostType = await this.livetvRepository.update(LivetvDTO.Id, LivetvDTO);
                const savedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                if(changeImg == true) {
                    var fname = savedData.livetvThumbnail.split('/')[2];
                    fs.unlinkSync('./public/TVThumbnails/'+fname);
                }
                const savedimg = await this.livetvRepository.update(LivetvDTO.Id,fileImg[0]);
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                if(updatedData) {
                    updatedData.livetvThumbnail = updatedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${updatedData.livetvThumbnail}`:'';
                    let msg = {
                        to : `${user.fcmToken}`,
                        collapse_key : "type_a",
                        notification : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv"
                        },
                        data : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv",
                            key_1 : "",
                            key_2 : ""
                        }
                    }
                    await this.notifyRepo.save({
                        title:'Change Live Tv',
                        message:`Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                        typeId:2,
                        userId:updatedData.updatedUser,
                        targetId:updatedData.Id,
                        status:true
                    })
                    if(user.fcmToken) {
                        
                        const nt = await this.sendNotify(msg);
                    }
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv details Update Failed')
                }
            } else {
                const updatePostType = await this.livetvRepository.update(LivetvDTO.Id, LivetvDTO);
                const savedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                if(changeImg == true) {
                    var fname = savedData.livetvThumbnail.split('/')[2];
                    fs.unlinkSync('./public/TVThumbnails/'+fname);
                }
                const savedimg = await this.livetvRepository.update(LivetvDTO.Id,fileImg[0]);
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                if(updatedData) {
                    updatedData.livetvThumbnail = updatedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${updatedData.livetvThumbnail}`:'';
                    let msg = {
                        to : `${user.fcmToken}`,
                        collapse_key : "type_a",
                        notification : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv"
                        },
                        data : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv",
                            key_1 : "",
                            key_2 : ""
                        }
                    }
                    await this.notifyRepo.save({
                        title:'Change Live Tv',
                        message:`Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                        typeId:2,
                        userId:updatedData.updatedUser,
                        targetId:updatedData.Id,
                        status:true
                    })
                    if(user.fcmToken) {
                        const nt = await this.sendNotify(msg);
                    }
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv details Update Failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    } */

    async updatelivetv(queryParams, LivetvDTO: EditLivetvDTO, request:Request): Promise<livetvResponseModel> {
        const response = new livetvResponseModel();
        try {
            const user = await this.useRepo.findOne({
                relations:['profile'],
                where:{Id:LivetvDTO.updatedUser}
            })
            if(queryParams.apiVersion == 1) {
                const updatePostType = await this.livetvRepository.update(LivetvDTO.Id, LivetvDTO);
                const savedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                if(updatedData) {
                    updatedData.livetvThumbnail = updatedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${updatedData.livetvThumbnail}`:'';
                    let msg = {
                        to : `${user.fcmToken}`,
                        collapse_key : "type_a",
                        notification : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv"
                        },
                        data : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv",
                            key_1 : "",
                            key_2 : ""
                        }
                    }
                    await this.notifyRepo.save({
                        title:'Change Live Tv',
                        message:`Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                        typeId:2,
                        userId:updatedData.updatedUser,
                        targetId:updatedData.Id,
                        status:true
                    })
                    if(user.fcmToken) {
                        
                        const nt = await this.sendNotify(msg);
                    }
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv details Update Failed')
                }
            } else {
                const updatePostType = await this.livetvRepository.update(LivetvDTO.Id, LivetvDTO);
                const savedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:LivetvDTO.Id}
                });
                if(updatedData) {
                    updatedData.livetvThumbnail = updatedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${updatedData.livetvThumbnail}`:'';
                    let msg = {
                        to : `${user.fcmToken}`,
                        collapse_key : "type_a",
                        notification : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv"
                        },
                        data : {
                            body : `Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                            title: "Change Live Tv",
                            key_1 : "",
                            key_2 : ""
                        }
                    }
                    await this.notifyRepo.save({
                        title:'Change Live Tv',
                        message:`Sri ${user.profile.firstName} is in Live in ${updatedData.livetvTitle} Click here to watch`,
                        typeId:2,
                        userId:updatedData.updatedUser,
                        targetId:updatedData.Id,
                        status:true
                    })
                    if(user.fcmToken) {
                        const nt = await this.sendNotify(msg);
                    }
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv details Update Failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
    async activeLivetv(queryParams, livetvActiveDTO:livetvActiveDTO, request:Request):Promise<livetvResponseModel> {
        const response = new livetvResponseModel();
        try {
            await this.livetvRepository.update({status:true},{isActive:0})
            if(queryParams.apiVersion == 1) { 
                const updateStatus = await this.livetvRepository.update(livetvActiveDTO.Id, livetvActiveDTO);
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:livetvActiveDTO.Id}
                });
                if(updateStatus) {
                    const final = {
                        Id:updatedData.Id,
                        livetvTitle:updatedData.livetvTitle,
                        livetvMessage:updatedData.livetvMessage,
                        livetvUrl:updatedData.livetvUrl,
                        isActive:updatedData.isActive == 0?false:true,
                        livetvThumbnail:updatedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${updatedData.livetvThumbnail}`:'',
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv active status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv active status update failed')
                }
            } else {
                const updateStatus = await this.livetvRepository.update(livetvActiveDTO.Id, livetvActiveDTO);
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:livetvActiveDTO.Id}
                });
                if(updateStatus) {
                    const final = {
                        Id:updatedData.Id,
                        livetvTitle:updatedData.livetvTitle,
                        livetvMessage:updatedData.livetvMessage,
                        livetvUrl:updatedData.livetvUrl,
                        isActive:updatedData.isActive == 0?false:true,
                        livetvThumbnail:updatedData.livetvThumbnail != null?`${process.env.WORKINGURL}/${updatedData.livetvThumbnail}`:'',
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv active status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv active status update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getlivetv(queryParams, roleId,request:Request): Promise<AlllivetvResponseModel> {
        const response = new AlllivetvResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                if(roleId == 1 || roleId == 2) {
                    const activeTypes = await this.livetvRepository.find({
                        where: {status: true},
                        order: { createdAt: 'DESC' }
                    });
                    if(activeTypes) {
                        const final = activeTypes.map((f) => {
                            return {
                                Id:f.Id,
                                livetvTitle:f.livetvTitle,
                                livetvMessage:f.livetvMessage,
                                livetvUrl:f.livetvUrl,
                                isActive:f.isActive == 0?false:true,
                                livetvThumbnail:f.livetvThumbnail != null?`${process.env.WORKINGURL}/${f.livetvThumbnail}`:'',
                            }
                        });
                        response.status = true;
                        response.data = final;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } else {
                    const activeTypes = await this.livetvRepository.find({
                        where: {status: true},
                        order: { createdAt: 'DESC' }
                    });
                    if(activeTypes) {
                        const final = activeTypes.map((f) => {
                            return {
                                Id:f.Id,
                                livetvTitle:f.livetvTitle,
                                livetvMessage:f.livetvMessage,
                                livetvUrl:f.livetvUrl,
                                isActive:f.isActive == 0?false:true,
                                livetvThumbnail:f.livetvThumbnail != null?`${process.env.WORKINGURL}/${f.livetvThumbnail}`:'',
                            }
                        });
                        response.status = true;
                        response.data = final;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                }                
            } else {
                if(roleId == 1 || roleId == 2) {
                    const activeTypes = await this.livetvRepository.find({
                        where: {status: true},
                        order: { createdAt: 'DESC' }
                    });
                    if(activeTypes) {
                        const final = activeTypes.map((f) => {
                            return {
                                Id:f.Id,
                                livetvTitle:f.livetvTitle,
                                livetvMessage:f.livetvMessage,
                                livetvUrl:f.livetvUrl,
                                isActive:f.isActive == 0?false:true,
                                livetvThumbnail:f.livetvThumbnail != null?`${process.env.WORKINGURL}/${f.livetvThumbnail}`:'',
                            }
                        });
                        response.status = true;
                        response.data = final;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } else {
                    const activeTypes = await this.livetvRepository.find({
                        where: {status: true,isActive:1},
                        order: { createdAt: 'DESC' }
                    });
                    if(activeTypes) {
                        const final = activeTypes.map((f) => {
                            return {
                                Id:f.Id,
                                livetvTitle:f.livetvTitle,
                                livetvMessage:f.livetvMessage,
                                livetvUrl:f.livetvUrl,
                                isActive:f.isActive == 0?false:true,
                                livetvThumbnail:f.livetvThumbnail != null?`${process.env.WORKINGURL}/${f.livetvThumbnail}`:'',
                            }
                        });
                        response.status = true;
                        response.data = final;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                }                
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getLiveTvById(queryParams,Id,request:Request):Promise<livetvResponseModel> {
        const response = new livetvResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activeTypes = await this.livetvRepository.findOne({
                    where: {Id:Id}
                });
                if(activeTypes) {
                    const final = {
                        Id:activeTypes.Id,
                        livetvTitle:activeTypes.livetvTitle,
                        livetvMessage:activeTypes.livetvMessage,
                        livetvUrl:activeTypes.livetvUrl,
                        isActive:activeTypes.isActive == 0?false:true,
                        livetvThumbnail:activeTypes.livetvThumbnail != null?`${process.env.WORKINGURL}/${activeTypes.livetvThumbnail}`:'',
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activeTypes = await this.livetvRepository.findOne({
                    where: {Id:Id}
                });
                if(activeTypes) {
                    const final = {
                        Id:activeTypes.Id,
                        livetvTitle:activeTypes.livetvTitle,
                        livetvMessage:activeTypes.livetvMessage,
                        livetvUrl:activeTypes.livetvUrl,
                        isActive:activeTypes.isActive == 0?false:true,
                        livetvThumbnail:activeTypes.livetvThumbnail != null?`${process.env.WORKINGURL}/${activeTypes.livetvThumbnail}`:'',
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updatelivetvStatus(queryParams, livetvStatusDTO:livetvStatusDTO, request:Request): Promise<livetvstatusResponseModel> {
        const response = new livetvstatusResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updateStatus = await this.livetvRepository.update(livetvStatusDTO.Id, livetvStatusDTO);
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:livetvStatusDTO.Id}
                });
                if(updateStatus) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv status update failed')
                }
            } else {
                const updateStatus = await this.livetvRepository.update(livetvStatusDTO.Id, livetvStatusDTO);
                const updatedData = await this.livetvRepository.findOne({
                    where:{Id:livetvStatusDTO.Id}
                });
                if(updateStatus) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv status update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}
